import React, { useState } from "react";
import FormGroup from "./FormGroup";
import Select, { SelectOption } from "components/Design/Input/Select/Select";
import { Field, FieldGroup } from "components/Design/Input/Field";
import Textarea from "components/Design/Input/Textarea";
import Checkbox from "components/Design/Input/Checkbox";
import Input from "components/Design/Input/Input";
import PhoneSelect from "components/Design/Input/Select/PhoneSelect";
import { useI18next } from "gatsby-plugin-react-i18next";
import { JA_INQUIRY_PLACEHOLDER } from "store/constants/formPlaceholder";

const Inquiry = ({ t }) => {
  const { language } = useI18next();
  return (
    <Field name="inquiry" label={t("Inquiry")}>
      <Textarea
        className={language === "ja" && "placeholder:pt-16"}
        placeholder={language === "ja" && JA_INQUIRY_PLACEHOLDER}
      />
    </Field>
  );
};

const PromotionalLetter = ({ t }) => {
  return (
    <FieldGroup name="promotional">
      <Checkbox type="checkbox">{t("receiveNewsletters")}</Checkbox>
    </FieldGroup>
  );
};

const ContactInformation = ({
  t,
  titleOption,
  nationalities,
  isWeddingInquiry,
}) => {
  const [showInput, setShowInput] = useState(false);
  const { language } = useI18next();

  return (
    <FormGroup label={t("contact information")}>
      <div className="flex">
        <div className={language === "ja" && "hidden"}>
          <Field name="title" className="select-prefix mr-6" label={t("Title")}>
            <Select>
              {titleOption.map((item) => (
                <SelectOption key={item.value} value={item.value}>
                  {item.label}
                </SelectOption>
              ))}
            </Select>
          </Field>
        </div>
        <Field name="fullname" label={t("Full Name")}>
          <Input />
        </Field>
      </div>

      {isWeddingInquiry && language === "ja" && (
        <Field name="hiraganaName" label={t("Hiragana Name")}>
          <Input />
        </Field>
      )}

      {nationalities && (
        <Field name="nationality" label={t("Nationality")}>
          <Select
            showSearch={showInput}
            onFocus={() => setShowInput(true)}
            onSelect={() => setShowInput(false)}>
            {nationalities.allNationalityJson.edges.map((nation) => (
              <SelectOption key={nation.node.name} value={nation.node.name}>
                {nation.node.name}
              </SelectOption>
            ))}
          </Select>
        </Field>
      )}

      <Field name="email" label={t("Email Address")}>
        <Input />
      </Field>

      <div className="flex space-x-6">
        <Field name="code" className="select-prefix">
          <PhoneSelect />
        </Field>

        <Field name="phone" label={t("Phone Number")}>
          <Input />
        </Field>
      </div>

      {language === "zh" && (
        <Field name="wechat" label={t("Wechat ID (Optional)")} prefixIcon>
          <Input prefixIcon="wechat" />
        </Field>
      )}

      <div>
        <FieldGroup
          name="contact"
          label={t("How would you prefer us to contact you?")}
          className="flex flex-col space-y-16">
          <Checkbox value="email">{t("Email")}</Checkbox>
          <Checkbox value="phone">{t("Phone Number")}</Checkbox>
        </FieldGroup>
      </div>
    </FormGroup>
  );
};

export { Inquiry, PromotionalLetter, ContactInformation };
